// Content class of the expand-chart modal. While it is open the drawer's own copy of the chart
// stays mounted underneath and comes first in the DOM, so a PNG export from the enlarged view has
// to scope its selector to this class to capture the copy the user is looking at.
export const EXPANDED_CHART_CLASS = 'channel-drawer-expanded';

// Stripped from PNG exports alongside the download dropdown.
export const EXPAND_BUTTON_CLASS = 'channel-drawer-expand-btn';

// Plot height for the trend, saturation and decay charts in the expand-chart modal.
export const EXPANDED_CHART_HEIGHT = 480;

// Axis text size for the drawer charts, and the larger size used in the expand-chart modal so the
// enlarged chart's labels scale with it.
export const AXIS_FONT_SIZE = 10;
export const EXPANDED_AXIS_FONT_SIZE = 12;

// Mixpanel labels for the modal_opened event fired when a drawer chart is expanded. Kept in one
// place so the names reported for each chart can't drift apart.
export const ExpandableChartName = {
  TREND: 'drawer trend chart',
  SATURATION: 'drawer saturation chart',
  DECAY: 'drawer decay chart',
  INTERCHANNEL: 'drawer inter-channel effects chart'
} as const;
export type ExpandableChartNameType =
  (typeof ExpandableChartName)[keyof typeof ExpandableChartName];
